import { render, staticRenderFns } from "./contractDetailTab.vue?vue&type=template&id=36d2d20e&scoped=true&"
import script from "./contractDetailTab.vue?vue&type=script&lang=js&"
export * from "./contractDetailTab.vue?vue&type=script&lang=js&"
import style0 from "./contractDetailTab.vue?vue&type=style&index=0&id=36d2d20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d2d20e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
